import { useApplicationUpdater } from '../../../queries/useApplicationUpdater';

/**
 * Returns a function that appends a default property stub to `information.properties.items`
 * in the React Query cache, if the property is not already present.
 *
 * Used by Property.tsx when the propertyGuid in the URL is not yet in the cache
 * (i.e. the user navigated directly to a new-property URL).
 *
 * @returns (propertyGuid: string) => void
 */
export function useAddPropertyToCache(): (propertyGuid: string) => void {
    const update = useApplicationUpdater();

    return (propertyGuid: string) => {
        update((old) => {
            const exists = old.information?.properties?.items?.some((p) => p.guid === propertyGuid);
            if (exists) return old;
            return {
                ...old,
                information: {
                    ...old.information,
                    properties: {
                        ...old.information.properties,
                        items: [
                            ...(old.information.properties?.items ?? []),
                            {
                                guid: propertyGuid,
                                isInitialCreate: true,
                                structureType: undefined,
                                address: { street1: '', street2: '', city: '', state: '', zipCode: '', county: '' },
                                nonRental: null,
                                rental: null,
                                rentalUnits: [],
                            },
                        ],
                    },
                },
            };
        });
    };
}
